'use client'
import React, { useCallback, useEffect, useState } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import Image from 'next/image'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import "../../../../../../styles/caseStudySlider.scss"
const tcoDubaiSlides = [
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/T%26Co/1.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/T%26Co/2.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/T%26Co/3.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/T%26Co/4.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/T%26Co/5.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/T%26Co/6.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/T%26Co/7.png',
  },
]

const lvmhMiamiSlides = [
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/LVMH/1.jpg',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/LVMH/2.jpg',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/LVMH/3.jpg',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/LVMH/4.jpg',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/LVMH/5.jpg',
  },
]

const SliderSection = ({ eventId }) => {
  const slides = eventId === 'tco-dubai-2024' ? tcoDubaiSlides : lvmhMiamiSlides

  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: 'center',
    skipSnaps: false,
  })

  const [selectedIndex, setSelectedIndex] = useState(0)

  const onSelect = useCallback(() => {
    if (!emblaApi) return
    setSelectedIndex(emblaApi.selectedScrollSnap())
  }, [emblaApi])

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev()
  }, [emblaApi])

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext()
  }, [emblaApi])

  useEffect(() => {
    if (!emblaApi) return
    emblaApi.on('select', onSelect)
  }, [emblaApi, onSelect])

  return (
    <section className='showcase-page max-w-full overflow-hidden pb-24 '>
      <div className='embla' ref={emblaRef}>
        <div className='embla__container flex'>
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`embla__slide max-w-full ${
                index === selectedIndex ? 'relative z-10' : ''
              }`}
            >
              <Image
                src={slide.img}
                width={800}
                height={450}
                className={`max-w-full w-full h-full object-cover ${
                  index !== selectedIndex ? 'py-[2.5%] px-[4.5%]' : 'p-0'
                }`}
                alt={`Slide ${index + 1}`}
              />
              {index === selectedIndex && (
                <button
                  className='embla__prev absolute !size-[15px] sm:!size-[20px] md:!size-[30px] transform left-[0] top-1/2 z-40 -translate-x-1/2 -translate-y-1/2 bg-[#a79779] hover:bg-black transition-colors duration-300 ease-in-out text-white w-10 h-10 rounded-full flex items-center justify-center'
                  onClick={scrollPrev}
                >
                  <ChevronLeft color={`white`} className='arrow-slider'  />
                </button>
              )}
              {index === selectedIndex && (
                <button
                  className='embla__next absolute !size-[15px] sm:!size-[20px] md:!size-[30px] transform right-[0] top-1/2 z-40 translate-x-1/2 -translate-y-1/2 bg-[#a79779] hover:bg-black transition-colors duration-300 ease-in-out text-white w-10 h-10 rounded-full flex items-center justify-center'
                  onClick={scrollNext}
                >
                  <ChevronRight color={`white`}  className='arrow-slider' />
                </button>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Arrows */}
    </section>
  )
}

export default SliderSection
